import { atom } from 'jotai';
import { DiscoverQs } from '@src/types/Discover';
import { FilterBuilt, MediaConstraints } from '@src/fragments/Filters/utils/MediaFilterBuilder';
import { TYPING_DEBOUNCE } from '@src/pages/Discover/DiscoverController';
import { SearchSuggestion, XCLUSION_SELECTIONS, XclusionSelection } from '@src/types/Filters';
import { ProductView } from 'common';

export const defaultFilter: DiscoverQs = {
  exact: [],
  caption: [],
  hashtag: [],
  label: [],
  source: [],
  media: [],
  audio: [],
  audioLang: [],
  rrStatus: [],
  creator: [],
  date: [],
  lang: [],
  productExact: [],
  productSimilar: [],
  collection: [],
  ownContent: [],
  productCatalogCountries: [],
  creatorCountries: [],
};

export const defaultFilterBuilt: FilterBuilt= {
  filter: {},
  search: undefined,
  productCatalogCountries: undefined,
  rawOnly: undefined,
  withStories: true,
}

export const InitialLibraryState = atom<{
  total: number;
  shoppableUGCs: number;
  totalEstimated: number;
  totalExact: number;
}>({
  total: 0,
  shoppableUGCs: 0,
  totalEstimated: 0,
  totalExact: 0,
});

export const FilterState = atom<DiscoverQs>(defaultFilter);

export const FilterBuiltState = atom<FilterBuilt>(defaultFilterBuilt);

export const filterSourceInputState = atom<string>('');

export const filterCollectionInputState = atom<string>('');

export const allCollectionState = atom<SearchSuggestion[]>([]);

export const filterLanguageInputState = atom<string>('');

export const filterAudioLanguageInputState = atom<string>('');

export const filterProductExactInputState = atom<string>('');

export const filterProductSimilarInputState = atom<string>('');

export const allProductState = atom<ProductView[]>([]);

export const filterCreatorInputState = atom<string>('');

export const filterCreatorXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterOwnContentInputState = atom<string>('');

export const filterOwnContentXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterLanguageXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterProductExactXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterProductSimilarXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterCollectionXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const filterCreatorCountriesInputState = atom<string>('');

export const filterProductCatalogCountriesInputState = atom<string>('');

export const filterCreatorCountriesXclusionState = atom<XclusionSelection>(XCLUSION_SELECTIONS[0]);

export const FacetState = atom<{
  enableFacet: boolean;
  typingDebounce: number;
  mediaConstraints: MediaConstraints;
  productIds?: string[];
}>({
  enableFacet: false,
  typingDebounce: TYPING_DEBOUNCE,
  mediaConstraints: {
    qs: {
      exact: [],
      caption: [],
      hashtag: [],
      label: [],
      source: [],
      media: [],
      audio: [],
      audioLang: [],
      rrStatus: [],
      creator: [],
      date: [],
      lang: [],
      productExact: [],
      productSimilar: [],
      ownContent: [],
      productCatalogCountries: [],
      creatorCountries: [],
    },
    isExactSearch: false,
    collections: [],
    filterCollectionXclusion: XCLUSION_SELECTIONS[0],
    filterOwnContentXclusion: XCLUSION_SELECTIONS[0],
    filterCreatorCountriesXclusion: XCLUSION_SELECTIONS[0],
    state: {
      user: null,
      groupMentionPages: {},
    },
  },
});
